(() => {
  'use strict';

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      currencyDisplay: 'code'
    }).format(cents / 100);
  }

  function getCents(text) {
    if (!text) return null;

    const match = text
      .replace(/,/g, '')
      .match(/\d+(?:\.\d{1,2})?/);

    if (!match) return null;

    const value = parseFloat(match[0]);

    return Number.isFinite(value)
      ? Math.round(value * 100)
      : null;
  }

  function findProductPrice(quantityInput) {
    let element = quantityInput.parentElement;

    while (element && element !== document.body) {
      const productPrice = element.querySelector(
        'product-price'
      );

      if (productPrice) {
        const salePrice = productPrice.querySelector(
          '.price_sale'
        );

        const regularPrice = productPrice.querySelector(
          '.price:not(.compare-at-price)'
        );

        if (salePrice) {
          return salePrice;
        }

        if (regularPrice) {
          return regularPrice;
        }
      }

      element = element.parentElement;
    }

    return null;
  }

  function setup(input) {
    if (input.dataset.quantityPriceReady === 'true') {
      return;
    }

    const priceElement = findProductPrice(input);

    if (!priceElement) {
      return;
    }

    /*
     * IMPORTANT:
     * We specifically read .price_sale first.
     *
     * For this product:
     * Sale price = $14.88
     * Compare-at price = $20.00
     *
     * Therefore $14.88 becomes the unit price.
     */

    const unitPrice = getCents(
      priceElement.textContent
    );

    if (unitPrice === null) {
      return;
    }

    input.dataset.quantityPriceReady = 'true';
    input.dataset.unitPrice = unitPrice;

    function updatePrice() {
      const quantity = Math.max(
        1,
        parseInt(input.value, 10) || 1
      );

      const basePrice = parseInt(
        input.dataset.unitPrice,
        10
      );

      if (!Number.isFinite(basePrice)) {
        return;
      }

      const total = basePrice * quantity;

      priceElement.textContent = formatMoney(total);
    }

    /*
     * Quantity input changes
     */
    input.addEventListener(
      'input',
      updatePrice
    );

    input.addEventListener(
      'change',
      updatePrice
    );

    /*
     * Horizon + / - buttons
     */
    const quantitySelector =
      input.closest('.quantity-selector');

    if (quantitySelector) {
      quantitySelector.addEventListener(
        'click',
        (event) => {
          const button = event.target.closest(
            '.quantity-plus, .quantity-minus'
          );

          if (!button) return;

          setTimeout(updatePrice, 50);
        }
      );
    }

    /*
     * Initial price
     */
    updatePrice();
  }

  function initialize() {
    document
      .querySelectorAll(
        '.quantity-selector input[name="quantity"]'
      )
      .forEach(setup);
  }

  /*
   * Start
   */
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialize
    );
  } else {
    initialize();
  }

  /*
   * Horizon can dynamically render sections,
   * so look for new quantity selectors.
   */
  const observer = new MutationObserver(() => {
    initialize();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
